/**
 * Labstep
 *
 * @module screens/Resource/Index
 * @desc Resource Index
 */

import GridNewIndexEntityViewLoader from 'labstep-web/grid/NewIndex/components/EntityViewLoader';
import GridNewIndexTemplateLoader from 'labstep-web/grid/NewIndex/components/TemplateLoader';
import type { IndexTemplatableEntity } from 'labstep-web/models';
import type { EntityView } from 'labstep-web/models/entity-view.model';
import { Resource } from 'labstep-web/models/resource.model';
import ScreensResourceIndexMaster from 'labstep-web/screens/Resource/Index/Master';
import { LocationService } from 'labstep-web/services/location.service';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { ScreensResourceIndexProps } from './types';

export const ScreensResourceIndex: React.FC<
  ScreensResourceIndexProps
> = ({ group, links, location }) => (
  <GridNewIndexTemplateLoader
    entityName={Resource.entityName}
    templateId={LocationService.getQueryParameter(
      location,
      'template_id',
    )}
  >
    {({ template }: { template?: IndexTemplatableEntity }) => (
      <GridNewIndexEntityViewLoader
        group={group}
        context="resource_index"
        entityName={Resource.entityName}
        defaultTemplate={template}
      >
        {({ entityView }: { entityView: EntityView }) => (
          <ScreensResourceIndexMaster
            entityView={entityView}
            group={group}
            links={links}
          />
        )}
      </GridNewIndexEntityViewLoader>
    )}
  </GridNewIndexTemplateLoader>
);

export default withRouter(ScreensResourceIndex);
